export default "__VITE_ASSET__Do481KQ$__"